/**
 * Do not edit directly
 * Generated on Mon, 26 Jun 2023 05:02:05 GMT
 */

module.exports = {
  // OLD COLOR CODE; will be deleted later when the new code fully implemented
  'wf-tertiary-grey': '#555c6aff',
  'wf-mid-grey': '#c1c5d0ff',
  majesty: '#392a49ff',
  'majesty-5': '#433552ff',
  'majesty-15': '#574a64ff',
  'majesty-30': '#746a80ff',
  'majesty-50': '#9c95a4ff',
  'violet-bright': '#9341a1ff',
  violet: '#7f5786ff',
  white: '#ffffffff',
  'grey-1': '#f5f6f7ff',
  'grey-2': '#e6e6e6ff',
  'grey-3': '#ddddddff',
  'cool-grey': '#e2e6f0ff',
  'grey-4': '#bdbdbdff',
  'grey-5': '#999999ff',
  'grey-6': '#555555ff',

  // NEW COLOR
  eucalyptus: '#828c74ff',
  'eucalyptus-light': '#d5dbccff',
  'eucalyptus-dark': '#6d795cff',
  acacia: '#3b3727ff',
  'dark-warm-grey': '#757065ff',
  'warm-grey': '#dbd8d1ff',
  'warmer-grey': '#f1efedff',
  'light-warm-grey': '#f8f7f6ff',
  white: '#ffffffff',
  black: '#141314ff',
  charcoal: '#323232ff',
  'cooper-clover': '#44471bff',
  millet: '#b08f5aff',
  sorghum: '#522f0cff',
  pindan: '#b2673bff',
  'blue-gum': '#91a39eff',
  lichen: '#a5cfc1ff',
  'gum-blossom': '#ff7c54ff',
  leucadendron: '#e5f76fff',
  flinders: '#95a147ff',
};
